<script>
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { emitter } from 'shared/helpers/mitt';

export default {
  components: {},
  mixins: [],
  props: {
    text: {
      type: String,
      default: '',
    },
    widgetId: {
      type: String,
      required: true,
    },
    editMode: {
      type: Boolean,
      default: false,
    },
  },
  validations: {
    headerText: {
      required,
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  data() {
    return {
      textEditorOpen: false,
      headerText: '',
    };
  },
  computed: {},
  mounted() {
    this.updateHeaderTextWithPropValue();
  },
  methods: {
    openTextEditor() {
      this.textEditorOpen = true;
    },
    setNewHeaderText() {
      this.textEditorOpen = false;
      emitter.emit('updatingWidgetHeaderTextInCustomDashboard', {
        widgetId: this.widgetId,
        newValue: this.headerText,
      });
    },
    updateHeaderTextWithPropValue() {
      this.headerText = this.text;
    },
  },
};
</script>

<template>
  <div class="e-header">
    <!-- START DISPLAY HEADER TEXT SECTION -->
    <div v-if="!textEditorOpen" class="container_align">
      <!-- TEXT HEADER CONTENT -->
      <div class="text-slate-800 dark:text-slate-800 w-full">
        {{ headerText }}
      </div>
      <!-- EDIT BUTTON -->
      <woot-button
        v-if="editMode"
        size="tiny"
        variant="clear"
        class="min-w-[1.5rem]"
        icon="edit"
        @click="openTextEditor"
      />
    </div>
    <!-- END DISPLAY HEADER TEXT SECTION -->

    <!-- START EDIT SECTION -->
    <div v-else class="container_align gap-1">
      <!-- EDIT HEADER TEXT INPUT -->
      <input
        v-if="textEditorOpen"
        v-model="headerText"
        type="text"
        class="!m-0 !text-xxs dark:!bg-woot-25 !h-6 !text-black-900"
        :placeholder="$t('CUSTOM_DASHBOARDS.EDIT_DASHBOARD.HEADER_PLACEHOLDER')"
      />
      <!-- SAVE NEW HEADER TEXT BUTTON -->
      <woot-button
        v-if="textEditorOpen"
        :disabled="v$.headerText.$invalid"
        class="z-[999] min-w-[1.5rem]"
        size="tiny"
        icon="save"
        @click="setNewHeaderText"
      />
    </div>
    <!-- END EDIT SECTION -->
  </div>
</template>

<style>
.e-header {
  border-top: 3px solid #2684ff;
  /* border-bottom: 1px solid #ecebef; */

  @apply h-[33px] bg-[#ecebef] w-full text-center absolute left-0 top-0;
}

.container_align {
  @apply flex justify-between items-center h-full;
}
</style>
